import React, { PropTypes } from 'react';
import { Paper } from 'material-ui';
import { connect } from 'react-redux';

const ContractingWindow = props => {
  const {
    leftNavNode,
    title,
    subtitle,
    titleBarRightWidgets,
    rightHeader,
    headerBgColor,
    headerStyle,
    toolbarNode,
    children,
  } = props;
  const rightContentTitle = title ? (
    <div
      style={{
        flex: '1 1 auto',
        fontSize: '17px',
        marginLeft: '16px',
        float: 'left',
        display: 'inline-block',
        overflowX: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        paddingTop: '2px',
      }}
    >
      {title}
    </div>
  ) : undefined;
  const headerButtons = titleBarRightWidgets ? <div style={{ flex: '1 0 auto', minWidth: '350px', display: 'flex', alignItems: 'center', marginRight: '4px', flexDirection: 'row-reverse' }}>{titleBarRightWidgets}</div> : undefined;
  const rightHeaderNode = (() => {
    if (rightHeader) return rightHeader;
    if (rightContentTitle || headerButtons) return <div style={{ backgroundColor: headerBgColor, height: '48px', color: '#fff', width: '100.1%', display: 'flex', justifyContent: 'space-between', ...headerStyle }}>{rightContentTitle}{headerButtons}</div>;
  })();
  const subtitleNode = subtitle ?
    <div style={{ height: '36px', borderBottom: subtitle.hideBottomBorder ? 'none' : '1px solid #efefef', margin: '0 2%', paddingRight: '4px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <span style={{ fontSize: '16px', color: 'black', fontWeight: '600', display: 'flex', alignItems: 'center' }}>{subtitle.name}</span>
      <div style={{ lineHeight: '36px', fontSize: '12px', height: '36px', display: 'flex', flexDirection: 'row-reverse' }}>
        <span style={{ verticalAlign: 'text-bottom', display: 'flex', float: 'right' }}>
          {subtitle.dateRange}
          {subtitle.versions}
        </span>
        {subtitle.subTitleWidgets}
      </div>
    </div> : undefined;

  return (
    <div>
      <Paper style={{ overflow: 'hidden', marginBottom: '70px', backgroundColor: '#f4f6fa' }}>
        <div className="contract-window" style={{ minHeight: 'calc(100vh - 199px)' }}>
          {leftNavNode}
          <div style={{ width: leftNavNode ? '78%' : '100%', backgroundColor: 'white' }}>
            {rightHeaderNode}
            {toolbarNode}
            {subtitle ? subtitle.secondLineSubtitle : null}
            {subtitleNode}
            {children}
          </div>
        </div>
      </Paper>
      <div style={{ height: '20px', width: '100%', background: 'transparent' }}/>
    </div>
  );
};

ContractingWindow.propTypes = {
  toolbarNode: PropTypes.node,
  rightHeader: PropTypes.node,
  title: PropTypes.any,
  titleBarRightWidgets: PropTypes.node,
  subtitle: PropTypes.object,
  leftNavNode: PropTypes.node,
  children: PropTypes.node,
  supplierChecked: PropTypes.bool,
  buyerChecked: PropTypes.bool,
  supplierCheckboxDisabled: PropTypes.bool,
  amendmentMessage: PropTypes.string,
  isAmendmentADraft: PropTypes.bool,
  buyerCheckboxDisabled: PropTypes.bool,
  disableCheckBoxes: PropTypes.bool,
  companyType: PropTypes.string,
  headerBgColor: PropTypes.string,
  headerStyle: PropTypes.object,
};
const mapStateToProps = ({ user }) => ({
  companyType: user.getIn(['user', 'type']),
});
export default connect(mapStateToProps)(ContractingWindow);



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/contracting-window.jsx